import { routes } from 'data'
import { routes as oldRouts } from 'old/data'
import { useRoutes } from 'react-router-dom'
import { getAdminVersion } from 'utils'

export const App = () => {
    const router = useRoutes(getAdminVersion() === 'v2' ? routes : oldRouts)
    return <>{router}</>
}
